import React from "react";
import dynamic from "next/dynamic";
import Box from "@mui/material/Box";

import AuthPageBase from "../common/AuthPageBase";
import Login from "./Login";

const SnackbarRefProvider = dynamic(
  () => import("../../../common/components/notification/SnackbarRefProvider"),
  { ssr: false }
);

const LoginBase: React.FC<{ email?: string }> = ({ email }) => {
  return (
    <Box py={{ xs: 0, md: 12 }}>
      <AuthPageBase title="Hey welcome back!" oAuthButtonText="Login with">
        <SnackbarRefProvider>
          <Login email={email} />
        </SnackbarRefProvider>
      </AuthPageBase>
    </Box>
  );
};

export default LoginBase;
